import React, { createContext, useContext } from "react";
import usePaginatedContent from "src/hooks/usePaginatedContent";

interface PaginationContext<T> {
  isSuccess: boolean;
  isLoading: boolean;
  isError: boolean;
  isFetching: boolean;
  pagination: PaginationData;
  data: T[];
  onNext: any;
  onBack: any;
  onSetPage: any;
}

const PaginationContext = createContext<PaginationContext<any>>({
  isSuccess: false,
  isLoading: false,
  isError: false,
  isFetching: false,
  pagination: {
    page: 1,
    pageCount: 1,
    pageSize: 10,
    total: 0,
  },
  data: [],
  onNext: () => null,
  onBack: () => null,
  onSetPage: () => null,
});

const PaginationProvider = ({
  initialData,
  queryFunction,
  queryKey,
  children,
}: {
  initialData?: FindResponse<any>;
  children: React.ReactNode;
  queryKey: string;
  queryFunction: any;
}) => {
  const value = usePaginatedContent({
    queryFunction,
    queryKey,
    initialData,
  });
  return (
    <PaginationContext.Provider value={value as PaginationContext<any>}>
      {children}
    </PaginationContext.Provider>
  );
};

const usePagination = () => {
  return useContext(PaginationContext);
};

export { PaginationProvider, usePagination };
